import React from 'react';
import { useResponsive } from '../../../hooks/useResponsive';
import GiftGiversPage from './GiftGiversPage';
import GiftGiversPageMobile from './GiftGiversPageMobile';

const GiftGiversPageWrapper: React.FC = () => {
  const { isMobile } = useResponsive();

  return isMobile ? <GiftGiversPageMobile /> : <GiftGiversPage />;
};

export default GiftGiversPageWrapper; 